import { Text, View } from "react-native";
import { MedicationModel } from "app/services/api/types/medications/models/MedicationModel";
import { formatDate } from "ui/utils/dateUtils";
import { getFullName } from "ui/utils/nameUtil";

interface Props {
  medication: MedicationModel;
}

export default function MedicationHistoryContent({ medication }: Props) {
  const history = medication.history ?? [];

  return (
    <View className="flex flex-col gap-y-4">
      {history.map((record) => (
        <View
          key={record.id}
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 bg-background-100 rounded-lg p-5"
        >
          <View className="flex flex-col">
            <Text className="text-gray-600 mb-2">Medication</Text>
            <Text className="font-semibold break-words">{record.name}</Text>
            <View className="flex-row items-center gap-x-2 flex-wrap">
              <Text className="text-sm text-typography-600 break-words">
                {record.dosage}
              </Text>
              <View className="bg-background-300 w-1.5 h-1.5 rounded-full" />
              <Text className="text-sm text-typography-600 break-words">
                {record.frequency}
              </Text>
              <Text className="text-sm text-typography-600 break-words">
                ({record.administration_method})
              </Text>
            </View>
          </View>
          <View className="flex flex-col">
            <Text className="text-gray-600 mb-2">Created by</Text>
            <Text className="text-black font-semibold break-words">
              {getFullName(record.created_by)}
            </Text>
          </View>
          <View className="flex flex-col">
            <View className="flex-row mb-2">
              <Text className="text-gray-600 mr-1">Created at:</Text>
              <Text className="text-black font-semibold break-words">
                {formatDate(record.created_at!)}
              </Text>
            </View>
            <View className="flex-row mb-2">
              <Text className="text-gray-600 mr-1">Discontinued at:</Text>
              <Text className="text-black font-semibold break-words">
                {formatDate(record.updated_at!)}
              </Text>
            </View>
          </View>
        </View>
      ))}
    </View>
  );
}
